// extracted by mini-css-extract-plugin
export default {"device":"PromoVideoModal-module--device--5c1a8","modalContent":"PromoVideoModal-module--modalContent--ecf3d","close":"PromoVideoModal-module--close--d0c5f"};